const calculadoraPublica = {
  path: "/public",
  component: () =>
    import(
      /* webpackChunkName: 'Calculadora-Layout' */ "@/modules/public/layouts/CalculadoraLayout"
    ),
  children: [
    {
      path: "calculadora",
      name: "calculadora-publica",
      component: () =>
        import(
          /* webpackChunkName: 'Calculadora-Publica-Index' */ "@/modules/public/pages/calculadora/"
        ),
    },
  ],
};

export default calculadoraPublica;
